<template>
  <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.59961 0H2.19961C1.31961 0 0.59961 0.72
             0.59961 1.6V14.4C0.59961 15.28 1.31961 16 2.19961 16H11.7996C12.6796
             16 13.3996 15.28 13.3996 14.4V4.8L8.59961 0ZM9.3996 7.2H6.19961V8H8.59961C9.0396
             8 9.3996 8.36 9.3996 8.8V11.2C9.3996 11.64 9.0396 12 8.59961
             12H7.79961V12.8H6.19961V12H4.59961V10.4H7.79961V9.6H5.39961C4.95961
             9.6 4.59961 9.24 4.59961 8.8V6.4C4.59961 5.96 4.95961 5.6 5.39961
             5.6H6.19961V4.8H7.79961V5.6H9.3996V7.2Z" fill="#0D7BC4"/>
  </svg>
</template>

<script>
export default {
  name: 'RequestRange'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Main/Icons/RequestRange.vue